/** Auto-generated by scripts/generate-release-metadata.mjs — do not edit */
import type { ReleaseBuildInfo } from "@structura/core/release-metadata";

export const RELEASE_BUILD_INFO: ReleaseBuildInfo = {
  "product": "fm",
  "version": "prod",
  "channel": "prod",
  "branch": "main",
  "commit": "cc0d9bef808d5c87bd1d604e4e3fd5008d0cad83",
  "builtAt": "2026-11-04T01:39:37.906Z",
  "releaseLabel": null,
  "environment": "development"
};
